import React from 'react';
import PropTypes from 'prop-types';
import { get, chunk, uniq } from 'lodash';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { menuToggler } from '@bd/bdcore-utilities';
import FeaturedHomesCarousel from './FeaturedHomesCarousel';
import { colors, typography } from '../../styles';
import HomeCard from '../../components/HomeCard';

const styles = css`
  margin-top: 115px;
  .HomesList_header{
    font-family:${typography.SansSerif};
    text-align:center;
    h2{
      color: ${colors.color1};
      font-weight: 300;
      font-size: 45px;
      letter-spacing: 0.75px;
      margin: 0;
      @media(min-width: 992px){
        font-size: 60px;
        letter-spacing: 1px;
      }
    }
    h3{
      text-transform: uppercase;
      font-size: 18px;
      font-weight: 900;
      letter-spacing: 2.25px;
      @media(min-width: 992px){
        font-size: 21px;
        letter-spacing: 2.63px;
      }
    }
  }
  .HomesList_list {
      display: none;
      @media(min-width: 992px) {
        display: flex;
        justify-content: center;
        width:100%;
        margin: auto;
      }
    }
    .HomesListMobile_list {
      justify-content: center;
      width: 100%;
      @media(min-width: 992px) {
        display: none;
      }
    }
    .Banner_Title {
      color:  white;
      font:700 18px/1 ${typography.SansSerif};
      padding:20px 30px;
      border:1px solid ${colors.color1};
      text-transform: uppercase;
      display: inline-block;
      margin-bottom: 24px;
      background: ${colors.color1};
      @media (min-width: 992px) {
        font:700 24px/1 ${typography.SansSerif};
      }
    }
`;

function FeaturedHomes({ page, homes }) {
  const featuredHomes = uniq(get(page, 'featured_homes', [])).map(_id => homes.find(home => home._id === _id)).filter(h => h);
  const homesCarousel = chunk(featuredHomes, 3).map(item =>
    (
      <div className="FHCarousel_wrapper row">
        {item.map(home =>
          <div key={home._id} className="col-md-6  col-xl-4"><HomeCard className="col-4" home={home} key={home._id} /></div>,
        )
        }
      </div>
    ),
  );
  const homesCarouselMobile = chunk(featuredHomes, 1).map(item =>
    (
      <div className="FHCarousel_wrapper row">
        {item.map(home =>
          <div key={home._id} className="col-md-6  col-xl-4"><HomeCard className="col-4" home={home} key={home._id} /></div>,
        )
        }
      </div>
    ),
  );
  return (
    <div className={styles}>
      <div className="HomesList_header">
        <h3>
          <span className="Banner_Title">Featured Available Homes</span>
        </h3>
      </div>
      <div className="d-flex HomesList_wrapper">
        <div className="HomesList_list">
          <FeaturedHomesCarousel
            items={homesCarousel}
          />
        </div>
        <div className="HomesListMobile_list">
          <FeaturedHomesCarousel
            items={homesCarouselMobile}
          />
        </div>
      </div>
    </div>
  );
}

FeaturedHomes.propTypes = {
  page: PropTypes.object.isRequired,
  homes: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    homes: true,
  },
)(menuToggler(FeaturedHomes));



// WEBPACK FOOTER //
// ./src/pages/IndexPage/FeaturedHomes.js